export enum LotBuildOverheadCostsPermissionEnum {
    None                = 0x00,
    CanView             = 0x01 << 0,
    CanCreate           = 0x01 << 1,
    CanEdit             = 0x01 << 2
}
